module.exports = {"530823101":"锦屏镇","530823102":"文井镇","530823103":"漫湾镇","530823104":"大朝山东镇","530823105":"花山镇","530823106":"大街镇","530823107":"太忠镇","530823108":"文龙镇","530823109":"安定镇","530823110":"景福镇","530823201":"曼等乡","530823205":"龙街乡","530823208":"林街乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530823.json
// module id = 2734
// module chunks = 0